import React, { useState } from "react";
import Footer from "../Footer";
import { NewNavbar } from "../Pages/NewNavbar";
import lock from "../../../assets/image/lock.png";

import CenterMode from "../Components/UI/CenterMode";
import { errorMessage, successMessage } from "../Util/Toaster";
import { postUserDetails, privateListUser } from "../../../api/leads";

type FormErrors = {
  name?: string;
  email?: string;
  phone?: string;
  purpose?: string;
  message?: string;
};
export default function PrivateListings() {
  const initialUserDetails = {
    name: "",
    email: "",
    phone: "",
    purpose: "",
    message: "",
  };
  const [userDetails, setUserDetails] = useState(initialUserDetails);
  const [errors, setErrors] = useState<FormErrors>({});

  const validate = (name, value) => {
    let errorMsg = "";

    const isEmpty = (str) => !str || !str.trim();
    const isAlpha = (str) => /^[a-zA-Z\s]+$/.test(str);
    const isEmail = (str) =>
      /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(str);
    const isPhone = (str) => {
      if (str.length > 14) return false;
      const validChars = /^[\d\s()+-]*$/;
      if (!validChars.test(str)) return false;
      return true;
    };

    if (isEmpty(value)) {
      errorMsg = "This field is required";
      return errorMsg;
    }

    switch (name) {
      case "name":
        if (!isAlpha(value)) {
          errorMsg = "Name can only contain letters and spaces";
        } else if (value.length < 2) {
          errorMsg = "Name must be at least 2 characters";
        } else if (value.length > 25) {
          errorMsg = "Name cannot exceed 25 characters";
        }
        break;
      case "email":
        if (!isEmail(value)) {
          errorMsg = "Invalid email format";
        }
        break;
      case "phone":
        if (!isPhone(value)) {
          errorMsg = "Phone number contains invalid characters";
        }
        break;
      case "purpose":
        if (value === "Purpose" || isEmpty(value)) {
          errorMsg = "Please select a purpose";
        }
        break;
      default:
        break;
    }

    return errorMsg;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setUserDetails((prev) => ({ ...prev, [name]: value }));

    const errorMsg = validate(name, value);
    setErrors((prev) => ({ ...prev, [name]: errorMsg }));
  };

  const handleSubmit = async (e, formType) => {
    e.preventDefault();
    let formValid = true;
    const newErrors = {};

    for (const key in userDetails) {
      const err = validate(key, userDetails[key]);
      if (err) formValid = false;
      newErrors[key] = err;
    }

    setErrors(newErrors);

    if (formValid) {
      // console.log("Form submitted successfully", userDetails, formType);

      try {
        const data = await privateListUser(userDetails);
        console.log("data", data.data);
        if (data.data > 0) {
          successMessage("Form Submit successfully");
          setUserDetails(initialUserDetails);
        } else {
          errorMessage("An error occurred during submission.");
        }
      } catch (error) {
        console.error("Submission error:", error);
        errorMessage("An error occurred during submission.");
      }
      setErrors({});
      // You can trigger form submission API here
    }
  };

  return (
    <>
      <NewNavbar buySellActive={false} />
      {/* Private listing section start */}
      <div className="private-list-banner py-5">
        <div className="container">
          <div className="row justify-content-center">
            <div className="d-flex justify-content-center flex-column align-items-center">
              <p className="invit-only">BY INVITATION ONLY</p>
              <h1 className="privat-main-heading">Private Listings</h1>
              <p className="sub-heading">
                Discover a world of exclusive, off-market listings reserved for
                qualified buyers and trusted investors.
                <br></br>
                These properties are not advertised publicly and require special
                access due to their discreet nature.
              </p>
            </div>
          </div>
        </div>
        <div className="border-section"></div>
        <div className="bottom-heading container p-0">
          <div className="row">
            <div className="col-md-6">
              <p className="bottom-sub-heading ">
                To maintain confidentiality and protect seller privacy, viewing
                these listings requires an approved access request.{" "}
                <b> Submit your details below -- </b> our team will review your
                request and respond shortly.
              </p>
            </div>
            <div className="col-md-6">
              <div className="get-access-btn-contain ">
                <button className="get-access-btn">GET ACCESS</button>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Private listing section end */}

      {/* Private Market section start */}
      <section className="private-market-section">
        <div className="container p-0">
          <div className="row">
            <div className="col-md-12">
              <div className="market-heading">STEP INTO THE PRIVATE MARKET</div>
              <div className="container">
                <div className="row">
                  <div className="col-12 ">
                    <p className="text-center form-heading">
                      Please fill out this form to request access to our
                      confidential listings. To maintain discretion, access is
                      reviewed and approved individually.
                    </p>
                  </div>
                  <form
                    onSubmit={(e) => handleSubmit(e, "Private_listing")}
                    className="private-market-form-section"
                    noValidate
                  >
                    <div className="row justify-content-center">
                      <div className="col-md-6 col-lg-5">
                        <div className="row justify-content-start quize-form">
                          <div className="col-12 mb-4">
                            <input
                              type="text"
                              className="w-100 guide-input"
                              placeholder="Name"
                              name="name"
                              value={userDetails.name}
                              onChange={handleChange}
                            />
                            {errors.name && (
                              <small className="text-danger">
                                {errors.name}
                              </small>
                            )}
                          </div>
                          <div className="col-12 mb-4">
                            <input
                              type="email"
                              className="w-100 guide-input"
                              placeholder="Email Address"
                              name="email"
                              value={userDetails.email}
                              onChange={handleChange}
                            />

                            {errors.name && (
                              <small className="text-danger">
                                {errors.name}
                              </small>
                            )}
                          </div>
                          <div className="col-6 mb-4">
                            <input
                              type="text"
                              className="w-100 guide-input"
                              placeholder="Phone"
                              name="phone"
                              value={userDetails.phone}
                              onChange={handleChange}
                            />
                            {errors.phone && (
                              <small className="text-danger">
                                {errors.phone}
                              </small>
                            )}
                          </div>
                          <div className="col-6 mb-4">
                            <select
                              className="guide-input w-100"
                              name="purpose"
                              aria-label="Default select example"
                              value={userDetails.purpose}
                              onChange={handleChange}
                            >
                              <option value="">Purpose</option>
                              <option value="All Options">All Options</option>
                              <option value="Luxury Listings">
                                Luxury Listings
                              </option>
                              <option value="Investment Opportunities">
                                Investment Opportunities
                              </option>
                            </select>
                            {errors.purpose && (
                              <small className="text-danger">
                                {errors.purpose}
                              </small>
                            )}
                          </div>
                        </div>
                      </div>

                      <div className="col-md-6 col-lg-5">
                        <div className="private-market-form-section h-100">
                          <div className="row justify-content-start quize-form h-100">
                            <div className="col-12 mb-4">
                              <textarea
                                className="w-100 guide-input h-100"
                                placeholder="Message: Tell us more about what you're looking for!"
                                name="message"
                                value={userDetails.message}
                                onChange={handleChange}
                              ></textarea>
                              {errors.message && (
                                <small className="text-danger">
                                  {errors.message}
                                </small>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>

                      <button className="submit-btn" type="submit">
                        ENTER THE PRIVATE PORTFOLIO
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Private Market section end */}
      <CenterMode />
      <div className="cta-section bg-lion container">
        <div className="cta">
          <div className="guide-icon-bg">
            <img src={lock} alt="Key" />
          </div>

          <h4>YOUR CURATED ADVANTAGE</h4>
          <h1>
            We take pride in offering a discreet, personalized experience for
            our clients.
          </h1>
        </div>
      </div>
      <Footer />
    </>
  );
}
